<template>
	<div class="auth-id-card-container">
		<div class="header">
			<van-icon name="arrow-left" class="back-icon" @click="$router.back()" />
			<span class="title">身份证认证</span>
		</div>

		<div class="logo-section">
			<img src="@/assets/icon/authIdCard/logo.png" alt="五行商户LOGO">
		</div>

		<div class="content">
			<van-form class="form-section" @submit="handleSubmit">
				<van-field label="真实姓名" v-model="formData.realName" class="form-input" placeholder="请输入您的真实姓名" />

				<van-field label="身份证号" v-model="formData.idCard" class="form-input" placeholder="请输入您的身份证号码" />

				<div class="upload-section">
					<div class="upload-wrapper">
						<div class="upload-item">
							<div class="upload-area" @click="handleUpload('front')">
								<van-uploader v-model="frontFiles" :after-read="(file) => onFileChange(file, 'front')"
									:max-count="1" :deletable="false" class="full-uploader">
									<div v-if="!formData.frontImage" class="upload-placeholder">
										<img src="@/assets/icon/authIdCard/icon_camera.png" alt="相机图标"
											class="camera-icon">
										<div class="upload-text">点击上传身份证正面</div>
									</div>
									<div v-else class="preview-wrapper">
										<img :src="formData.frontImage" class="preview-image" alt="身份证正面">
									</div>
								</van-uploader>
							</div>
						</div>

						<div class="upload-item">
							<div class="upload-area" @click="handleUpload('back')">
								<van-uploader v-model="backFiles" :after-read="(file) => onFileChange(file, 'back')"
									:max-count="1" :deletable="false" class="full-uploader">
									<div v-if="!formData.backImage" class="upload-placeholder">
										<img src="@/assets/icon/authIdCard/icon_camera.png" alt="相机图标"
											class="camera-icon">
										<div class="upload-text">点击上传身份证反面</div>
									</div>
									<div v-else class="preview-wrapper">
										<img :src="formData.backImage" class="preview-image" alt="身份证反面">
									</div>
								</van-uploader>
							</div>
						</div>
					</div>
				</div>

				<van-button class="submit-btn" native-type="submit" :loading="loading" loading-text="提交中...">
					提交认证
				</van-button>
			</van-form>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	export default {
		name: "authIdCard",
		data() {
			return {
				formData: {
					realName: '',
					idCard: '',
					frontImage: '',
					backImage: ''
				},
				frontFiles: [],
				backFiles: [],
				loading: false
			};
		},
		created() {
			this.$parent.footer('authIdCard', false);
		},
		methods: {
			validateIdCard(val) {
				const idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				return idCardRegex.test(val);
			},

			handleUpload(type) {
				if (type === 'front') {
					document.querySelector('.upload-item:first-child .van-uploader__upload').click();
				} else {
					document.querySelector('.upload-item:last-child .van-uploader__upload').click();
				}
			},

			onFileChange(file, type) {
				if (Array.isArray(file)) {
					file = file[0];
				}

				if (file) {
					if (file.file) {
						const fileObj = file.file;
						if (!fileObj.type.match('image.*')) {
							this.$toast('请选择图片文件');
							return;
						}

						if (fileObj.size > 20 * 1024 * 1024) {
							this.$toast('图片大小不能超过20MB');
							return;
						}

						const reader = new FileReader();
						reader.onload = (e) => {
							if (type === 'front') {
								this.formData.frontImage = e.target.result;
							} else {
								this.formData.backImage = e.target.result;
							}
						};
						reader.readAsDataURL(fileObj);
					} else {
						if (!file.type.match('image.*')) {
							this.$toast('请选择图片文件');
							return;
						}

						const reader = new FileReader();
						reader.onload = (e) => {
							if (type === 'front') {
								this.formData.frontImage = e.target.result;
							} else {
								this.formData.backImage = e.target.result;
							}
						};
						reader.readAsDataURL(file);
					}
				}
			},

			async handleSubmit() {
				if (!this.formData.realName) {
					this.$toast('请输入真实姓名');
					return;
				}

				if (!this.formData.idCard) {
					this.$toast('请输入身份证号码');
					return;
				}

				// if (!this.validateIdCard(this.formData.idCard)) {
				// 	this.$toast('请输入正确的身份证号码');
				// 	return;
				// }

				if (!this.formData.frontImage) {
					this.$toast('请上传身份证正面照片');
					return;
				}

				if (!this.formData.backImage) {
					this.$toast('请上传身份证反面照片');
					return;
				}

				console.log("提交表单数据:", this.formData);

				this.loading = true;

				try {
					Fetch('/user/idCard_add', {
						frontImage: this.formData.frontImage,
						backImage: this.formData.backImage
					}).then(r => {
						if (r.code === 1) {
							this.$toast(r.msg || '身份信息认证成功');
							setTimeout(() => {
								this.$router.push('/authAccount');
							}, 1500);
						} else {
							this.$toast(r.msg || '认证失败');
						}
					})
				} catch (error) {
					this.$toast('提交失败，请重试');
					console.error('提交失败:', error);
				} finally {
					this.loading = false;
				}
			}
		}
	};
</script>

<style scoped>
	.auth-id-card-container {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		color: #b22222;
		font-family: "微软雅黑", sans-serif;
		height: 100vh;
		width: 10rem;
		background: url(~@/assets/icon/authIdCard/bg.png) 100% no-repeat;
		background-size: 100% 100%;
	}

	.header {
		position: relative;
		width: 100%;
		height: 12vw;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(to right, #f8f8f8, #fff);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	}

	.header .back-icon {
		position: absolute;
		left: 4vw;
		top: 50%;
		transform: translateY(-50%);
		font-size: 6vw;
		color: #333;
	}

	.header .title {
		font-size: 4.8vw;
		font-weight: 600;
		color: #333;
		font-family: "微软雅黑", sans-serif;
	}

	.logo-section {
		text-align: center;
		padding: 8vw 0 6vw;
	}

	.logo-section img {
		width: 80%;
	}

	.content {
		width: 100%;
		padding: 5vw;
		box-sizing: border-box;
	}

	.form-section {
		width: 100%;
		padding: 5vw;
		border-radius: 10px;
		background-color: #fff;
		box-sizing: border-box;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
	}

	.form-group {
		margin-bottom: 6vw;
	}

	.form-label {
		font-size: 4.5vw;
		color: #333;
		margin-bottom: 3vw;
		font-weight: 500;
		font-family: "微软雅黑", sans-serif;
		text-align: left;
	}

	.form-input {
		width: 100%;
		height: 12vw;
		border-radius: 1.5vw;
		padding: 0;
		font-size: 4.2vw;
		color: #333;
		box-sizing: border-box;
		align-items: center;
	}

	.form-input::placeholder {
		color: #999;
	}

	/* 上传区域样式优化 */
	.upload-section {
		margin-top: 6vw;
		margin-bottom: 8vw;
	}

	.upload-title {
		font-size: 4.5vw;
		color: #333;
		margin-bottom: 4vw;
		font-weight: 500;
		font-family: "微软雅黑", sans-serif;
		text-align: left;
	}

	.upload-wrapper {
		display: flex;
		flex-direction: column;
		gap: 6vw;
	}

	.upload-item {
		margin-bottom: 2vw;
	}

	.upload-area {
		width: 100%;
		height: 35vw;
		border: 2px dashed #ddd;
		border-radius: 2.5vw;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
		cursor: pointer;
		transition: border-color 0.3s;
		background-color: #fafafa;
	}

	.upload-area:hover {
		border-color: #b22222;
	}

	/* van-uploader容器铺满父级容器 */
	.full-uploader {
		width: 100% !important;
		height: 100% !important;
	}

	.upload-placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		padding: 4vw;
		box-sizing: border-box;
	}

	.camera-icon {
		width: 15vw;
		height: 15vw;
		margin-bottom: 3vw;
		object-fit: contain;
	}

	.upload-text {
		margin-top: 2vw;
		font-size: 3.8vw;
		color: #666;
		text-align: center;
		line-height: 1.4;
	}

	.preview-wrapper {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.preview-image {
		width: 100%;
		height: 100%;
		object-fit: contain;
		background-color: #f5f5f5;
	}

	.upload-tip {
		font-size: 3.5vw;
		color: #999;
		margin-top: 2.5vw;
		text-align: left;
		padding-left: 2vw;
	}

	.submit-btn {
		width: 100%;
		height: 12vw;
		background: linear-gradient(to right, #ddbb90, #ebcaa0);
		color: white;
		font-size: 4.8vw;
		font-weight: 600;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5vw;
		margin-top: 10vw;
		cursor: pointer;
		box-shadow: 0 2px 8px rgba(178, 34, 34, 0.3);
		font-family: "微软雅黑", sans-serif;
		transition: all 0.2s;
		border: none;
	}

	.submit-btn:active {
		transform: scale(0.98);
		opacity: 0.9;
	}

	/* van-field样式覆盖 */
	:deep(.van-field__label) {
		width: 4em;
		font-size: 4.2vw;
	}

	:deep(.van-field__control) {
		font-size: 4.2vw;
		color: #333;
	}

	:deep(.van-field__body) {
		height: 12vw;
	}

	/* van-uploader样式深度覆盖 */
	:deep(.van-uploader__wrapper) {
		width: 100%;
		height: 100%;
		display: block;
	}

	:deep(.van-uploader__upload) {
		width: 100% !important;
		height: 100% !important;
		margin: 0 !important;
		padding: 0 !important;
		border: none !important;
		background: transparent !important;
		border-radius: 2.5vw;
	}

	:deep(.van-uploader__preview) {
		width: 100% !important;
		height: 100% !important;
		margin: 0 !important;
	}

	:deep(.van-uploader__preview-image) {
		width: 100% !important;
		height: 100% !important;
		border-radius: 2.5vw;
		object-fit: contain !important;
	}

	:deep(.van-uploader__preview-delete) {
		top: 1vw;
		right: 1vw;
		width: 8vw;
		height: 8vw;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 50%;
	}

	:deep(.van-uploader__preview-delete-icon) {
		color: white;
		font-size: 5vw;
	}
</style>